import React, { Component } from 'react'
import { Table, Button } from 'antd'

const Opraiton = (props) => {
  return (
    <div>
       <Button type="primary" size='small' style={{margin:'0 5px',fontSize:'12px'}}>关闭信用</Button>
       <Button type="primary" size='small' style={{margin:'0 5px',fontSize:'12px'}}>申请提升额度</Button>
       <Button type="primary" size='small' style={{margin:'0 5px',fontSize:'12px'}}>融资</Button>
       <Button type="primary" size='small' style={{margin:'0 5px',fontSize:'12px'}}>关闭</Button>
    </div>
  )
}

const columns = [
  { title: '金融机构', dataIndex: 'name', key: 'name' },
  { title: '融资产品代号', dataIndex: 'age', key: 'age' },
  { title: '融资产品名称呢过', dataIndex: 'address', key: 'address' },
  { title: '授信状态', dataIndex: 'address1', key: 'address1' },
  { title: '授信额度', dataIndex: 'address2', key: 'address2' },
  { title: '总放款', dataIndex: 'address3', key: 'address3' },
  { title: '融资余额', dataIndex: 'address4', key: 'address4' },
  { title: '融资产品名称呢过', dataIndex: 'address5', key: 'address5' },

  {
    title: '操作',
    dataIndex: '',
    width: 300,
    fixed: 'right',
    key: 'x',
    render: () => <Opraiton></Opraiton>,
  },
].map(el=>{
  return {
    ...el,
    ellipsis: true,
    align: 'center'
  }
})

const data = [
  {
    key: 1,
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
    description: 'My name is John Brown, I am 32 years old, living in New York No. 1 Lake Park.',
  },
  {
    key: 2,
    name: 'Jim Green',
    age: 42,
    address: 'London No. 1 Lake Park',
    description: 'My name is Jim Green, I am 42 years old, living in London No. 1 Lake Park.',
  },
  {
    key: 3,
    name: 'Joe Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
    description: 'My name is Joe Black, I am 32 years old, living in Sidney No. 1 Lake Park.',
  },
  {
    key: 4,
    name: 'Joe Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
    description: 'My name is Joe Black, I am 32 years old, living in Sidney No. 1 Lake Park.',
  },
  {
    key: 5,
    name: 'Joe Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
    description: 'My name is Joe Black, I am 32 years old, living in Sidney No. 1 Lake Park.',
  },
  {
    key: 6,
    name: 'Joe Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
    description: 'My name is Joe Black, I am 32 years old, living in Sidney No. 1 Lake Park.',
  },
]


export default function UseProduct() {
  return (
    <Table
      columns={columns}
      expandedRowRender={record => <p style={{ margin: 0 }}>{record.description}</p>}
      dataSource={data}
      bordered
    />
  )
}




// WEBPACK FOOTER //
// ./apps/pages/main/workbench/CoreFirm/UseProduct.js